import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "plan-card-error"
}
const _hoisted_2 = { key: 0 }

import { computed, ref, onBeforeMount } from 'vue'
import { useWait } from '@/app/composables/useWait'
import { assertNotNull } from '@/helpers/typing'

import type {
  AppStoreBillingView,
  BillingView,
  PlanView,
} from '@/models/billing'
import { platform } from '@/services/platform'
import {
  GoogleBillingUnavailableError,
  UserCancelledError,
} from '@/services/cordova.purchase.types'
import { ValidationError } from '@/models/error'

import AppButton from '@/app/components/button/AppButton.vue'
import SubscribePopup from './SubscribePopup.vue'
import BillingApplePriceComparison16218 from './BillingApplePriceComparison16218.vue'

import { Mixpanel } from '@/analytics/mixpanel'
import { trialByPlanV2_18369Treatment } from '@/services/ab/18369_trial_by_plan'


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingSubscribeButton',
  props: {
    billing: {},
    plan: {},
    location: {},
    label: {}
  },
  setup(__props: any) {

const props = __props

const wait = useWait()

const errorRef = ref<string | null>(null)
const popup = ref<InstanceType<typeof SubscribePopup> | null>(null)
const iosComparisonPopup = ref<InstanceType<
  typeof BillingApplePriceComparison16218
> | null>(null)

const useButtonOutlinedStyle = props.plan.id === 'plan_monthly'
const buttonVariantClass = `subscribe-button--${props.plan.id}`
const buttonText = computed(() => {
  if (props.label) {
    return props.label
  }

  if (props.billing.isTrialOver) {
    return 'Subscribe'
  }

  if (trialByPlanV2_18369Treatment()) {
    return props.plan.id === 'plan_annual'
      ? 'Start 14-day Free Trial'
      : 'Select Plan'
  }

  return 'Start Free Trial'
})

const isAndroidApp = ref<boolean>(false)
onBeforeMount(async () => {
  isAndroidApp.value = await platform.isNativeAndroidApp()
})

async function subscribe(): Promise<void> {
  Mixpanel.trackStartTrialButton(props.plan, props.location || '')

  if (!props.billing.isAppStore()) {
    return assertNotNull(popup.value).show()
  }

  if (props.billing.showExternalPayment16218) {
    return assertNotNull(iosComparisonPopup.value).show()
  }

  await appStoreSubscribe()
}

async function appStoreSubscribe(): Promise<void> {
  try {
    errorRef.value = null
    wait.start('BillingSubscribe')
    await props.billing.subscribeTo(props.plan)
    wait.end('BillingSubscribe')
  } catch (error) {
    if (error instanceof UserCancelledError) {
      errorRef.value = 'cancelled'
    } else if (error instanceof ValidationError) {
      errorRef.value = error.getOne('receipt')
    } else if (error instanceof GoogleBillingUnavailableError) {
      errorRef.value =
        "We couldn't initiate your purchase. Please ensure that you are logged into your Google account on your device, and you have installed the latest version of Google Play. Alternatively, you can subscribe at https://www.shortform.com/app/billing in a web browser."
    } else if ('message' in (error as any)) {
      errorRef.value = (error as any).message
    } else {
      errorRef.value = ''
    }
    wait.end('BillingSubscribe')
  }
  iosComparisonPopup.value?.close()
}

return (_ctx: any,_cache: any) => {
  const _component_button_spinner = _resolveComponent("button-spinner")!
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_wait, {
      class: "subscribe-button__wrapper",
      for: "BillingSubscribe"
    }, {
      waiting: _withCtx(() => [
        _createVNode(AppButton, {
          class: _normalizeClass(["subscribe-button", buttonVariantClass]),
          outlined: useButtonOutlinedStyle,
          disabled: ""
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createTextVNode(" Subscribing ", -1)),
            _createVNode(_component_button_spinner)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(AppButton, {
          class: _normalizeClass(["subscribe-button", buttonVariantClass]),
          outlined: useButtonOutlinedStyle,
          onClick: subscribe
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(buttonText.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (errorRef.value !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createTextVNode(" Error subscribing", -1)),
          (errorRef.value !== '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, ": " + _toDisplayString(errorRef.value), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (__props.billing.showExternalPayment16218)
      ? (_openBlock(), _createBlock(BillingApplePriceComparison16218, {
          key: 1,
          ref_key: "iosComparisonPopup",
          ref: iosComparisonPopup,
          billing: __props.billing as AppStoreBillingView,
          plan: __props.plan,
          onAppStoreSubscribe: appStoreSubscribe
        }, null, 8, ["billing", "plan"]))
      : (_openBlock(), _createBlock(SubscribePopup, {
          key: 2,
          ref_key: "popup",
          ref: popup,
          billing: __props.billing,
          plan: __props.plan
        }, null, 8, ["billing", "plan"]))
  ], 64))
}
}

})